import PaycashPaymentInfo from './PaycashPaymentInfoContainer';

export default PaycashPaymentInfo;
